// -----------------  FETCH MENU LINKS -----------------
export const FETCH_MENU_LINKS_LOADING = 'FETCH_MENU_LINKS_LOADING';
export const FETCH_MENU_LINKS_SUCCESS = 'FETCH_MENU_LINKS_SUCCESS';
export const FETCH_MENU_LINKS_ERROR = 'FETCH_MENU_LINKS_ERROR';
